import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../dashboard.service';
import { Router, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-inverter-gain-table',
  templateUrl: './inverter-gain-table.component.html',
  styleUrls: ['./inverter-gain-table.component.scss']
})
export class InverterGainTableComponent implements OnInit {
  gainDetailsForm: FormGroup;
  search: any = "";
  limit = 10;
  offset: any = 0;
  dataObject: any = {};
  gainObject: any = {};
  editUserObject: any = {};
  gainList: [];
  gainCount: any;
  page: 1;
  srcString: any='';
  isEditing: any;
  role: any;
  makeId: any;
  roleName: any;
  SadminAccess: any = [];
  access: any;

  @HostListener('getAllGainDetails')

  private ResponseVerifiedGainList: Subject<any> = new Subject();
  private ResponseVerifiedParamGainList: Subject<any> = new Subject();
  private ResponseVerifiedGainAddList: Subject<any> = new Subject();

  constructor(private modalService1: NgbModal, private dashbord: DashboardService, private toastr: ToastrService,
    private router: Router, private fb: FormBuilder) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    }else if(this.role == '5'){
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'Make & Gain') {
          this.access = x.access
        }
      })
    }

    if (this.roleName == 'admin' ||  this.roleName == 'slave_admin') {
      this.getAllGainDetails(this.search, this.limit, this.offset);

    }

    this.gainDetailsForm = this.fb.group({
      param_01_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_01_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_03_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_03_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_05_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_05_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_07_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_07_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_09_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_09_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_11_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_11_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_13_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_13_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_15_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_15_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_17_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_17_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_19_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_19_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_21_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_21_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_23_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_23_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_25_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_25_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_27_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_27_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_29_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_29_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_31_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_31_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_33_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_33_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_35_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_35_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_37_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_37_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_39_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_39_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],

      param_02_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_02_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_04_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_04_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_06_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_06_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_08_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_08_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_10_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_10_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_12_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_12_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_14_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_14_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_16_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_16_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_18_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_18_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_20_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_20_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_22_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_22_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_24_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_24_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_26_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_26_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_28_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_28_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_30_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_30_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_32_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_32_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_34_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_34_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_36_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_36_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_38_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_38_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_40_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_40_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_46_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_46_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_47_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_47_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_48_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_48_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_49_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_49_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_50_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_50_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_51_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_51_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_52_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_52_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_53_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_53_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_54_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_54_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_55_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_55_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_56_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_56_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_57_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_57_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_58_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_58_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_59_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_59_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_60_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_60_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_61_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_61_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_62_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_62_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_63_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_63_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_64_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_64_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_65_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_65_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_66_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_66_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_67_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_67_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_68_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_68_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_69_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_69_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_70_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_70_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_71_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_71_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_72_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_72_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_73_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_73_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_74_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_74_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_75_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_75_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_76_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_76_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_77_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_77_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_78_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_78_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_79_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_79_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_80_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_80_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_81_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_81_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_82_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_82_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_83_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_83_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_84_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_84_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_85_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_85_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_86_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_86_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_87_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_87_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_88_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_88_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_89_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_89_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_90_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_90_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_91_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_91_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_92_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_92_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_93_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_93_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_94_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_94_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_95_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_95_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_96_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_96_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_97_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_97_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_98_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_98_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_99_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_99_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_100_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_100_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_101_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_101_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_102_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_102_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_103_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_103_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_104_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_104_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      param_105_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      param_105_gain: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
    })

  }

  get f() { return this.gainDetailsForm.controls; }

  //get all inverter gain details api call
  getAllGainDetails(search, limit, offset) {
    if (offset == 0) {
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset
    }
    this.dashbord.getGainList(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGainList))
      .subscribe(
        async data => {
          this.gainCount = 0;
          if (data.status) {
            this.gainCount = data.count;
            this.gainList = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.gainList = data.resultObject;
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPageNew(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getAllGainDetails(this.srcString, this.limit, this.offset);
  }

  ngOnDestroy() {
    this.ResponseVerifiedGainList.next();
    this.ResponseVerifiedGainList.complete();
    this.ResponseVerifiedParamGainList.next();
    this.ResponseVerifiedParamGainList.complete();
  }

  AddGain(AddGains, makeId) {
    // this.modalService1.open(viewDevices);
    this.modalService1.open(AddGains, {
      size: <any>'xl', backdrop: 'static',
      keyboard: false
    });
    //   this.modalRef = this.modalService.show(showAgency);
    this.makeId = makeId;
    this.getParamGainDetails(this.makeId);
  }

  editGain(userId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
      }
    };
    this.router.navigate(['/inject-solar/add-inverter-gain/'], navigationExtras)
  }

  getParamGainDetails(makeId) {
    this.editUserObject = {
      make_id: makeId
    };
    this.dashbord.getParamGain(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedParamGainList))
      .subscribe(
        async data => {
          if (data.status) {
            this.editUserObject = {};
            this.gainDetailsForm.get('param_01_name').setValue(data.resultObject.param_01_name);
            this.gainDetailsForm.get('param_01_gain').setValue(data.resultObject.param_01_gain);
            this.gainDetailsForm.get('param_02_name').setValue(data.resultObject.param_02_name);
            this.gainDetailsForm.get('param_02_gain').setValue(data.resultObject.param_02_gain);
            this.gainDetailsForm.get('param_03_name').setValue(data.resultObject.param_03_name);
            this.gainDetailsForm.get('param_03_gain').setValue(data.resultObject.param_03_gain);
            this.gainDetailsForm.get('param_04_name').setValue(data.resultObject.param_04_name);
            this.gainDetailsForm.get('param_04_name').setValue(data.resultObject.param_04_name);
            this.gainDetailsForm.get('param_04_gain').setValue(data.resultObject.param_04_gain);
            this.gainDetailsForm.get('param_05_name').setValue(data.resultObject.param_05_name);
            this.gainDetailsForm.get('param_05_gain').setValue(data.resultObject.param_05_gain);
            this.gainDetailsForm.get('param_06_name').setValue(data.resultObject.param_06_name);
            this.gainDetailsForm.get('param_06_gain').setValue(data.resultObject.param_06_gain);
            this.gainDetailsForm.get('param_07_name').setValue(data.resultObject.param_07_name);
            this.gainDetailsForm.get('param_07_gain').setValue(data.resultObject.param_07_gain);
            this.gainDetailsForm.get('param_08_name').setValue(data.resultObject.param_08_name);
            this.gainDetailsForm.get('param_08_gain').setValue(data.resultObject.param_08_gain);
            this.gainDetailsForm.get('param_09_name').setValue(data.resultObject.param_09_name);
            this.gainDetailsForm.get('param_09_gain').setValue(data.resultObject.param_09_gain);
            this.gainDetailsForm.get('param_10_name').setValue(data.resultObject.param_10_name);
            this.gainDetailsForm.get('param_10_gain').setValue(data.resultObject.param_10_gain);
            this.gainDetailsForm.get('param_11_name').setValue(data.resultObject.param_11_name);
            this.gainDetailsForm.get('param_11_gain').setValue(data.resultObject.param_11_gain);
            this.gainDetailsForm.get('param_12_name').setValue(data.resultObject.param_12_name);
            this.gainDetailsForm.get('param_12_gain').setValue(data.resultObject.param_12_gain);
            this.gainDetailsForm.get('param_13_name').setValue(data.resultObject.param_13_name);
            this.gainDetailsForm.get('param_13_gain').setValue(data.resultObject.param_13_gain);
            this.gainDetailsForm.get('param_14_name').setValue(data.resultObject.param_14_name);
            this.gainDetailsForm.get('param_14_gain').setValue(data.resultObject.param_14_gain);
            this.gainDetailsForm.get('param_15_name').setValue(data.resultObject.param_15_name);
            this.gainDetailsForm.get('param_15_gain').setValue(data.resultObject.param_15_gain);
            this.gainDetailsForm.get('param_16_name').setValue(data.resultObject.param_16_name);
            this.gainDetailsForm.get('param_16_gain').setValue(data.resultObject.param_16_gain);
            this.gainDetailsForm.get('param_17_name').setValue(data.resultObject.param_17_name);
            this.gainDetailsForm.get('param_17_gain').setValue(data.resultObject.param_17_gain);
            this.gainDetailsForm.get('param_18_name').setValue(data.resultObject.param_18_name);
            this.gainDetailsForm.get('param_18_gain').setValue(data.resultObject.param_18_gain);
            this.gainDetailsForm.get('param_19_name').setValue(data.resultObject.param_19_name);
            this.gainDetailsForm.get('param_19_gain').setValue(data.resultObject.param_19_gain);
            this.gainDetailsForm.get('param_20_name').setValue(data.resultObject.param_20_name);
            this.gainDetailsForm.get('param_20_gain').setValue(data.resultObject.param_20_gain);
            this.gainDetailsForm.get('param_21_name').setValue(data.resultObject.param_21_name);
            this.gainDetailsForm.get('param_21_gain').setValue(data.resultObject.param_21_gain);
            this.gainDetailsForm.get('param_22_name').setValue(data.resultObject.param_22_name);
            this.gainDetailsForm.get('param_22_gain').setValue(data.resultObject.param_22_gain);
            this.gainDetailsForm.get('param_23_name').setValue(data.resultObject.param_23_name);
            this.gainDetailsForm.get('param_23_gain').setValue(data.resultObject.param_23_gain);
            this.gainDetailsForm.get('param_24_name').setValue(data.resultObject.param_24_name);
            this.gainDetailsForm.get('param_24_gain').setValue(data.resultObject.param_24_gain);
            this.gainDetailsForm.get('param_25_name').setValue(data.resultObject.param_25_name);
            this.gainDetailsForm.get('param_25_gain').setValue(data.resultObject.param_25_gain);
            this.gainDetailsForm.get('param_26_name').setValue(data.resultObject.param_26_name);
            this.gainDetailsForm.get('param_26_gain').setValue(data.resultObject.param_26_gain);
            this.gainDetailsForm.get('param_27_name').setValue(data.resultObject.param_27_name);
            this.gainDetailsForm.get('param_27_gain').setValue(data.resultObject.param_27_gain);
            this.gainDetailsForm.get('param_28_name').setValue(data.resultObject.param_28_name);
            this.gainDetailsForm.get('param_28_gain').setValue(data.resultObject.param_28_gain);
            this.gainDetailsForm.get('param_29_name').setValue(data.resultObject.param_29_name);
            this.gainDetailsForm.get('param_29_gain').setValue(data.resultObject.param_29_gain);
            this.gainDetailsForm.get('param_30_name').setValue(data.resultObject.param_30_name);
            this.gainDetailsForm.get('param_30_gain').setValue(data.resultObject.param_30_gain);
            this.gainDetailsForm.get('param_31_name').setValue(data.resultObject.param_31_name);
            this.gainDetailsForm.get('param_31_gain').setValue(data.resultObject.param_31_gain);
            this.gainDetailsForm.get('param_32_name').setValue(data.resultObject.param_32_name);
            this.gainDetailsForm.get('param_32_gain').setValue(data.resultObject.param_32_gain);
            this.gainDetailsForm.get('param_33_name').setValue(data.resultObject.param_33_name);
            this.gainDetailsForm.get('param_33_gain').setValue(data.resultObject.param_33_gain);
            this.gainDetailsForm.get('param_34_name').setValue(data.resultObject.param_34_name);
            this.gainDetailsForm.get('param_34_gain').setValue(data.resultObject.param_34_gain);
            this.gainDetailsForm.get('param_35_name').setValue(data.resultObject.param_35_name);
            this.gainDetailsForm.get('param_35_gain').setValue(data.resultObject.param_35_gain);
            this.gainDetailsForm.get('param_36_name').setValue(data.resultObject.param_36_name);
            this.gainDetailsForm.get('param_36_gain').setValue(data.resultObject.param_36_gain);
            this.gainDetailsForm.get('param_37_name').setValue(data.resultObject.param_37_name);
            this.gainDetailsForm.get('param_37_gain').setValue(data.resultObject.param_37_gain);
            this.gainDetailsForm.get('param_38_name').setValue(data.resultObject.param_38_name);
            this.gainDetailsForm.get('param_38_gain').setValue(data.resultObject.param_38_gain);
            this.gainDetailsForm.get('param_39_name').setValue(data.resultObject.param_39_name);
            this.gainDetailsForm.get('param_39_gain').setValue(data.resultObject.param_39_gain);
            this.gainDetailsForm.get('param_40_name').setValue(data.resultObject.param_40_name);
            this.gainDetailsForm.get('param_40_gain').setValue(data.resultObject.param_40_gain);
            this.gainDetailsForm.get('param_46_name').setValue(data.resultObject.param_46_name);
            this.gainDetailsForm.get('param_46_gain').setValue(data.resultObject.param_46_gain);
            this.gainDetailsForm.get('param_47_name').setValue(data.resultObject.param_47_name);
            this.gainDetailsForm.get('param_47_gain').setValue(data.resultObject.param_47_gain);
            this.gainDetailsForm.get('param_48_name').setValue(data.resultObject.param_48_name);
            this.gainDetailsForm.get('param_48_gain').setValue(data.resultObject.param_48_gain);
            this.gainDetailsForm.get('param_49_name').setValue(data.resultObject.param_49_name);
            this.gainDetailsForm.get('param_49_gain').setValue(data.resultObject.param_49_gain);
            this.gainDetailsForm.get('param_50_name').setValue(data.resultObject.param_50_name);
            this.gainDetailsForm.get('param_50_gain').setValue(data.resultObject.param_50_gain);
            this.gainDetailsForm.get('param_51_name').setValue(data.resultObject.param_51_name);
            this.gainDetailsForm.get('param_51_gain').setValue(data.resultObject.param_51_gain);
            this.gainDetailsForm.get('param_52_name').setValue(data.resultObject.param_52_name);
            this.gainDetailsForm.get('param_52_gain').setValue(data.resultObject.param_52_gain);
            this.gainDetailsForm.get('param_53_name').setValue(data.resultObject.param_53_name);
            this.gainDetailsForm.get('param_53_gain').setValue(data.resultObject.param_53_gain);
            this.gainDetailsForm.get('param_54_name').setValue(data.resultObject.param_54_name);
            this.gainDetailsForm.get('param_54_gain').setValue(data.resultObject.param_54_gain);
            this.gainDetailsForm.get('param_55_name').setValue(data.resultObject.param_55_name);
            this.gainDetailsForm.get('param_55_gain').setValue(data.resultObject.param_55_gain);
            this.gainDetailsForm.get('param_56_name').setValue(data.resultObject.param_56_name);
            this.gainDetailsForm.get('param_56_gain').setValue(data.resultObject.param_56_gain);
            this.gainDetailsForm.get('param_57_name').setValue(data.resultObject.param_57_name);
            this.gainDetailsForm.get('param_57_gain').setValue(data.resultObject.param_57_gain);
            this.gainDetailsForm.get('param_58_name').setValue(data.resultObject.param_58_name);
            this.gainDetailsForm.get('param_58_gain').setValue(data.resultObject.param_58_gain);
            this.gainDetailsForm.get('param_59_name').setValue(data.resultObject.param_59_name);
            this.gainDetailsForm.get('param_59_gain').setValue(data.resultObject.param_59_gain);
            this.gainDetailsForm.get('param_60_name').setValue(data.resultObject.param_60_name);
            this.gainDetailsForm.get('param_60_gain').setValue(data.resultObject.param_60_gain);
            this.gainDetailsForm.get('param_61_name').setValue(data.resultObject.param_61_name);
            this.gainDetailsForm.get('param_61_gain').setValue(data.resultObject.param_61_gain);
            this.gainDetailsForm.get('param_62_name').setValue(data.resultObject.param_62_name);
            this.gainDetailsForm.get('param_62_gain').setValue(data.resultObject.param_62_gain);
            this.gainDetailsForm.get('param_63_name').setValue(data.resultObject.param_63_name);
            this.gainDetailsForm.get('param_63_gain').setValue(data.resultObject.param_63_gain);
            this.gainDetailsForm.get('param_64_name').setValue(data.resultObject.param_64_name);
            this.gainDetailsForm.get('param_64_gain').setValue(data.resultObject.param_64_gain);
            this.gainDetailsForm.get('param_65_name').setValue(data.resultObject.param_65_name);
            this.gainDetailsForm.get('param_65_gain').setValue(data.resultObject.param_65_gain);
            this.gainDetailsForm.get('param_66_name').setValue(data.resultObject.param_66_name);
            this.gainDetailsForm.get('param_66_gain').setValue(data.resultObject.param_66_gain);
            this.gainDetailsForm.get('param_67_name').setValue(data.resultObject.param_67_name);
            this.gainDetailsForm.get('param_67_gain').setValue(data.resultObject.param_67_gain);
            this.gainDetailsForm.get('param_68_name').setValue(data.resultObject.param_68_name);
            this.gainDetailsForm.get('param_68_gain').setValue(data.resultObject.param_68_gain);
            this.gainDetailsForm.get('param_69_name').setValue(data.resultObject.param_69_name);
            this.gainDetailsForm.get('param_69_gain').setValue(data.resultObject.param_69_gain);
            this.gainDetailsForm.get('param_70_name').setValue(data.resultObject.param_70_name);
            this.gainDetailsForm.get('param_70_gain').setValue(data.resultObject.param_70_gain);
            this.gainDetailsForm.get('param_71_name').setValue(data.resultObject.param_71_name);
            this.gainDetailsForm.get('param_71_gain').setValue(data.resultObject.param_71_gain);
            this.gainDetailsForm.get('param_72_name').setValue(data.resultObject.param_72_name);
            this.gainDetailsForm.get('param_72_gain').setValue(data.resultObject.param_72_gain);
            this.gainDetailsForm.get('param_73_name').setValue(data.resultObject.param_73_name);
            this.gainDetailsForm.get('param_73_gain').setValue(data.resultObject.param_73_gain);
            this.gainDetailsForm.get('param_74_name').setValue(data.resultObject.param_74_name);
            this.gainDetailsForm.get('param_74_gain').setValue(data.resultObject.param_74_gain);
            this.gainDetailsForm.get('param_75_name').setValue(data.resultObject.param_75_name);
            this.gainDetailsForm.get('param_75_gain').setValue(data.resultObject.param_75_gain);
            this.gainDetailsForm.get('param_76_name').setValue(data.resultObject.param_76_name);
            this.gainDetailsForm.get('param_76_gain').setValue(data.resultObject.param_76_gain);
            this.gainDetailsForm.get('param_77_name').setValue(data.resultObject.param_77_name);
            this.gainDetailsForm.get('param_77_gain').setValue(data.resultObject.param_77_gain);
            this.gainDetailsForm.get('param_78_name').setValue(data.resultObject.param_78_name);
            this.gainDetailsForm.get('param_78_gain').setValue(data.resultObject.param_78_gain);
            this.gainDetailsForm.get('param_79_name').setValue(data.resultObject.param_79_name);
            this.gainDetailsForm.get('param_79_gain').setValue(data.resultObject.param_79_gain);
            this.gainDetailsForm.get('param_80_name').setValue(data.resultObject.param_80_name);
            this.gainDetailsForm.get('param_80_gain').setValue(data.resultObject.param_80_gain);
            this.gainDetailsForm.get('param_81_name').setValue(data.resultObject.param_81_name);
            this.gainDetailsForm.get('param_81_gain').setValue(data.resultObject.param_81_gain);
            this.gainDetailsForm.get('param_82_name').setValue(data.resultObject.param_82_name);
            this.gainDetailsForm.get('param_82_gain').setValue(data.resultObject.param_82_gain);
            this.gainDetailsForm.get('param_83_name').setValue(data.resultObject.param_83_name);
            this.gainDetailsForm.get('param_83_gain').setValue(data.resultObject.param_83_gain);
            this.gainDetailsForm.get('param_84_name').setValue(data.resultObject.param_84_name);
            this.gainDetailsForm.get('param_84_gain').setValue(data.resultObject.param_84_gain);
            this.gainDetailsForm.get('param_85_name').setValue(data.resultObject.param_85_name);
            this.gainDetailsForm.get('param_85_gain').setValue(data.resultObject.param_85_gain);
            this.gainDetailsForm.get('param_86_name').setValue(data.resultObject.param_86_name);
            this.gainDetailsForm.get('param_86_gain').setValue(data.resultObject.param_86_gain);
            this.gainDetailsForm.get('param_87_name').setValue(data.resultObject.param_87_name);
            this.gainDetailsForm.get('param_87_gain').setValue(data.resultObject.param_87_gain);
            this.gainDetailsForm.get('param_88_name').setValue(data.resultObject.param_88_name);
            this.gainDetailsForm.get('param_88_gain').setValue(data.resultObject.param_88_gain);
            this.gainDetailsForm.get('param_89_name').setValue(data.resultObject.param_89_name);
            this.gainDetailsForm.get('param_89_gain').setValue(data.resultObject.param_89_gain);
            this.gainDetailsForm.get('param_90_name').setValue(data.resultObject.param_90_name);
            this.gainDetailsForm.get('param_90_gain').setValue(data.resultObject.param_90_gain);
            this.gainDetailsForm.get('param_91_name').setValue(data.resultObject.param_91_name);
            this.gainDetailsForm.get('param_91_gain').setValue(data.resultObject.param_91_gain);
            this.gainDetailsForm.get('param_92_name').setValue(data.resultObject.param_92_name);
            this.gainDetailsForm.get('param_92_gain').setValue(data.resultObject.param_92_gain);
            this.gainDetailsForm.get('param_93_name').setValue(data.resultObject.param_93_name);
            this.gainDetailsForm.get('param_93_gain').setValue(data.resultObject.param_93_gain);
            this.gainDetailsForm.get('param_94_name').setValue(data.resultObject.param_94_name);
            this.gainDetailsForm.get('param_94_gain').setValue(data.resultObject.param_94_gain);
            this.gainDetailsForm.get('param_95_name').setValue(data.resultObject.param_95_name);
            this.gainDetailsForm.get('param_95_gain').setValue(data.resultObject.param_95_gain);
            this.gainDetailsForm.get('param_96_name').setValue(data.resultObject.param_96_name);
            this.gainDetailsForm.get('param_96_gain').setValue(data.resultObject.param_96_gain);
            this.gainDetailsForm.get('param_97_name').setValue(data.resultObject.param_97_name);
            this.gainDetailsForm.get('param_97_gain').setValue(data.resultObject.param_97_gain);
            this.gainDetailsForm.get('param_98_name').setValue(data.resultObject.param_98_name);
            this.gainDetailsForm.get('param_98_gain').setValue(data.resultObject.param_98_gain);
            this.gainDetailsForm.get('param_99_name').setValue(data.resultObject.param_99_name);
            this.gainDetailsForm.get('param_99_gain').setValue(data.resultObject.param_99_gain);
            this.gainDetailsForm.get('param_100_name').setValue(data.resultObject.param_100_name);
            this.gainDetailsForm.get('param_100_gain').setValue(data.resultObject.param_100_gain);
            this.gainDetailsForm.get('param_101_name').setValue(data.resultObject.param_101_name);
            this.gainDetailsForm.get('param_101_gain').setValue(data.resultObject.param_101_gain);
            this.gainDetailsForm.get('param_102_name').setValue(data.resultObject.param_102_name);
            this.gainDetailsForm.get('param_102_gain').setValue(data.resultObject.param_102_gain);
            this.gainDetailsForm.get('param_103_name').setValue(data.resultObject.param_103_name);
            this.gainDetailsForm.get('param_103_gain').setValue(data.resultObject.param_103_gain);
            this.gainDetailsForm.get('param_104_name').setValue(data.resultObject.param_104_name);
            this.gainDetailsForm.get('param_104_gain').setValue(data.resultObject.param_104_gain);
            this.gainDetailsForm.get('param_105_name').setValue(data.resultObject.param_105_name);
            this.gainDetailsForm.get('param_105_gain').setValue(data.resultObject.param_105_gain);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  addParamGain(id, make_id) {
    var gainInfo =
    {
      "id": id,
      "make_id": make_id,
      "param_01_name": this.gainDetailsForm.controls['param_01_name'].value,
      "param_01_gain": this.gainDetailsForm.controls['param_01_gain'].value,
      "param_02_name": this.gainDetailsForm.controls['param_02_name'].value,
      "param_02_gain": this.gainDetailsForm.controls['param_02_gain'].value,
      "param_03_name": this.gainDetailsForm.controls['param_03_name'].value,
      "param_03_gain": this.gainDetailsForm.controls['param_03_gain'].value,
      "param_04_name": this.gainDetailsForm.controls['param_04_name'].value,
      "param_04_gain": this.gainDetailsForm.controls['param_04_gain'].value,
      "param_05_name": this.gainDetailsForm.controls['param_05_name'].value,
      "param_05_gain": this.gainDetailsForm.controls['param_05_gain'].value,
      "param_06_name": this.gainDetailsForm.controls['param_06_name'].value,
      "param_06_gain": this.gainDetailsForm.controls['param_06_gain'].value,
      "param_07_name": this.gainDetailsForm.controls['param_07_name'].value,
      "param_07_gain": this.gainDetailsForm.controls['param_07_gain'].value,
      "param_08_name": this.gainDetailsForm.controls['param_08_name'].value,
      "param_08_gain": this.gainDetailsForm.controls['param_08_gain'].value,
      "param_09_name": this.gainDetailsForm.controls['param_09_name'].value,
      "param_09_gain": this.gainDetailsForm.controls['param_09_gain'].value,
      "param_10_name": this.gainDetailsForm.controls['param_10_name'].value,
      "param_10_gain": this.gainDetailsForm.controls['param_10_gain'].value,
      "param_11_name": this.gainDetailsForm.controls['param_11_name'].value,
      "param_11_gain": this.gainDetailsForm.controls['param_11_gain'].value,
      "param_12_name": this.gainDetailsForm.controls['param_12_name'].value,
      "param_12_gain": this.gainDetailsForm.controls['param_12_gain'].value,
      "param_13_name": this.gainDetailsForm.controls['param_13_name'].value,
      "param_13_gain": this.gainDetailsForm.controls['param_13_gain'].value,
      "param_14_name": this.gainDetailsForm.controls['param_14_name'].value,
      "param_14_gain": this.gainDetailsForm.controls['param_14_gain'].value,
      "param_15_name": this.gainDetailsForm.controls['param_15_name'].value,
      "param_15_gain": this.gainDetailsForm.controls['param_15_gain'].value,
      "param_16_name": this.gainDetailsForm.controls['param_16_name'].value,
      "param_16_gain": this.gainDetailsForm.controls['param_16_gain'].value,
      "param_17_name": this.gainDetailsForm.controls['param_17_name'].value,
      "param_17_gain": this.gainDetailsForm.controls['param_17_gain'].value,
      "param_18_name": this.gainDetailsForm.controls['param_18_name'].value,
      "param_18_gain": this.gainDetailsForm.controls['param_18_gain'].value,
      "param_19_name": this.gainDetailsForm.controls['param_19_name'].value,
      "param_19_gain": this.gainDetailsForm.controls['param_19_gain'].value,
      "param_20_name": this.gainDetailsForm.controls['param_20_name'].value,
      "param_20_gain": this.gainDetailsForm.controls['param_20_gain'].value,
      "param_21_name": this.gainDetailsForm.controls['param_21_name'].value,
      "param_21_gain": this.gainDetailsForm.controls['param_21_gain'].value,
      "param_22_name": this.gainDetailsForm.controls['param_22_name'].value,
      "param_22_gain": this.gainDetailsForm.controls['param_22_gain'].value,
      "param_23_name": this.gainDetailsForm.controls['param_23_name'].value,
      "param_23_gain": this.gainDetailsForm.controls['param_23_gain'].value,
      "param_24_name": this.gainDetailsForm.controls['param_24_name'].value,
      "param_24_gain": this.gainDetailsForm.controls['param_24_gain'].value,
      "param_25_name": this.gainDetailsForm.controls['param_25_name'].value,
      "param_25_gain": this.gainDetailsForm.controls['param_25_gain'].value,
      "param_26_name": this.gainDetailsForm.controls['param_26_name'].value,
      "param_26_gain": this.gainDetailsForm.controls['param_26_gain'].value,
      "param_27_name": this.gainDetailsForm.controls['param_27_name'].value,
      "param_27_gain": this.gainDetailsForm.controls['param_27_gain'].value,
      "param_28_name": this.gainDetailsForm.controls['param_28_name'].value,
      "param_28_gain": this.gainDetailsForm.controls['param_28_gain'].value,
      "param_29_name": this.gainDetailsForm.controls['param_29_name'].value,
      "param_29_gain": this.gainDetailsForm.controls['param_29_gain'].value,
      "param_30_name": this.gainDetailsForm.controls['param_30_name'].value,
      "param_30_gain": this.gainDetailsForm.controls['param_30_gain'].value,
      "param_31_name": this.gainDetailsForm.controls['param_31_name'].value,
      "param_31_gain": this.gainDetailsForm.controls['param_31_gain'].value,
      "param_32_name": this.gainDetailsForm.controls['param_32_name'].value,
      "param_32_gain": this.gainDetailsForm.controls['param_32_gain'].value,
      "param_33_name": this.gainDetailsForm.controls['param_33_name'].value,
      "param_33_gain": this.gainDetailsForm.controls['param_33_gain'].value,
      "param_34_name": this.gainDetailsForm.controls['param_34_name'].value,
      "param_34_gain": this.gainDetailsForm.controls['param_34_gain'].value,
      "param_35_name": this.gainDetailsForm.controls['param_35_name'].value,
      "param_35_gain": this.gainDetailsForm.controls['param_35_gain'].value,
      "param_36_name": this.gainDetailsForm.controls['param_36_name'].value,
      "param_36_gain": this.gainDetailsForm.controls['param_36_gain'].value,
      "param_37_name": this.gainDetailsForm.controls['param_37_name'].value,
      "param_37_gain": this.gainDetailsForm.controls['param_37_gain'].value,
      "param_38_name": this.gainDetailsForm.controls['param_38_name'].value,
      "param_38_gain": this.gainDetailsForm.controls['param_38_gain'].value,
      "param_39_name": this.gainDetailsForm.controls['param_39_name'].value,
      "param_39_gain": this.gainDetailsForm.controls['param_39_gain'].value,
      "param_40_name": this.gainDetailsForm.controls['param_40_name'].value,
      "param_40_gain": this.gainDetailsForm.controls['param_40_gain'].value,
      "param_46_name": this.gainDetailsForm.controls['param_46_name'].value,
      "param_46_gain": this.gainDetailsForm.controls['param_46_gain'].value,
      "param_47_name": this.gainDetailsForm.controls['param_47_name'].value,
      "param_47_gain": this.gainDetailsForm.controls['param_47_gain'].value,
      "param_48_name": this.gainDetailsForm.controls['param_48_name'].value,
      "param_48_gain": this.gainDetailsForm.controls['param_48_gain'].value,
      "param_49_name": this.gainDetailsForm.controls['param_49_name'].value,
      "param_49_gain": this.gainDetailsForm.controls['param_49_gain'].value,
      "param_50_name": this.gainDetailsForm.controls['param_50_name'].value,
      "param_50_gain": this.gainDetailsForm.controls['param_50_gain'].value,
      "param_51_name": this.gainDetailsForm.controls['param_51_name'].value,
      "param_51_gain": this.gainDetailsForm.controls['param_51_gain'].value,
      "param_52_name": this.gainDetailsForm.controls['param_52_name'].value,
      "param_52_gain": this.gainDetailsForm.controls['param_52_gain'].value,
      "param_53_name": this.gainDetailsForm.controls['param_53_name'].value,
      "param_53_gain": this.gainDetailsForm.controls['param_53_gain'].value,
      "param_54_name": this.gainDetailsForm.controls['param_54_name'].value,
      "param_54_gain": this.gainDetailsForm.controls['param_54_gain'].value,
      "param_55_name": this.gainDetailsForm.controls['param_55_name'].value,
      "param_55_gain": this.gainDetailsForm.controls['param_55_gain'].value,
      "param_56_name": this.gainDetailsForm.controls['param_56_name'].value,
      "param_56_gain": this.gainDetailsForm.controls['param_56_gain'].value,
      "param_57_name": this.gainDetailsForm.controls['param_57_name'].value,
      "param_57_gain": this.gainDetailsForm.controls['param_57_gain'].value,
      "param_58_name": this.gainDetailsForm.controls['param_58_name'].value,
      "param_58_gain": this.gainDetailsForm.controls['param_58_gain'].value,
      "param_59_name": this.gainDetailsForm.controls['param_59_name'].value,
      "param_59_gain": this.gainDetailsForm.controls['param_59_gain'].value,
      "param_60_name": this.gainDetailsForm.controls['param_60_name'].value,
      "param_60_gain": this.gainDetailsForm.controls['param_60_gain'].value,
      "param_61_name": this.gainDetailsForm.controls['param_61_name'].value,
      "param_61_gain": this.gainDetailsForm.controls['param_61_gain'].value,
      "param_62_name": this.gainDetailsForm.controls['param_62_name'].value,
      "param_62_gain": this.gainDetailsForm.controls['param_62_gain'].value,
      "param_63_name": this.gainDetailsForm.controls['param_63_name'].value,
      "param_63_gain": this.gainDetailsForm.controls['param_63_gain'].value,
      "param_64_name": this.gainDetailsForm.controls['param_64_name'].value,
      "param_64_gain": this.gainDetailsForm.controls['param_64_gain'].value,
      "param_65_name": this.gainDetailsForm.controls['param_65_name'].value,
      "param_65_gain": this.gainDetailsForm.controls['param_65_gain'].value,
      "param_66_name": this.gainDetailsForm.controls['param_66_name'].value,
      "param_66_gain": this.gainDetailsForm.controls['param_66_gain'].value,
      "param_67_name": this.gainDetailsForm.controls['param_67_name'].value,
      "param_67_gain": this.gainDetailsForm.controls['param_67_gain'].value,
      "param_68_name": this.gainDetailsForm.controls['param_68_name'].value,
      "param_68_gain": this.gainDetailsForm.controls['param_68_gain'].value,
      "param_69_name": this.gainDetailsForm.controls['param_69_name'].value,
      "param_69_gain": this.gainDetailsForm.controls['param_69_gain'].value,
      "param_70_name": this.gainDetailsForm.controls['param_70_name'].value,
      "param_70_gain": this.gainDetailsForm.controls['param_70_gain'].value,
      "param_71_name": this.gainDetailsForm.controls['param_71_name'].value,
      "param_71_gain": this.gainDetailsForm.controls['param_71_gain'].value,
      "param_72_name": this.gainDetailsForm.controls['param_72_name'].value,
      "param_72_gain": this.gainDetailsForm.controls['param_72_gain'].value,
      "param_73_name": this.gainDetailsForm.controls['param_73_name'].value,
      "param_73_gain": this.gainDetailsForm.controls['param_73_gain'].value,
      "param_74_name": this.gainDetailsForm.controls['param_74_name'].value,
      "param_74_gain": this.gainDetailsForm.controls['param_74_gain'].value,
      "param_75_name": this.gainDetailsForm.controls['param_75_name'].value,
      "param_75_gain": this.gainDetailsForm.controls['param_75_gain'].value,
      "param_76_name": this.gainDetailsForm.controls['param_76_name'].value,
      "param_76_gain": this.gainDetailsForm.controls['param_76_gain'].value,
      "param_77_name": this.gainDetailsForm.controls['param_77_name'].value,
      "param_77_gain": this.gainDetailsForm.controls['param_77_gain'].value,
      "param_78_name": this.gainDetailsForm.controls['param_78_name'].value,
      "param_78_gain": this.gainDetailsForm.controls['param_78_gain'].value,
      "param_79_name": this.gainDetailsForm.controls['param_79_name'].value,
      "param_79_gain": this.gainDetailsForm.controls['param_79_gain'].value,
      "param_80_name": this.gainDetailsForm.controls['param_80_name'].value,
      "param_80_gain": this.gainDetailsForm.controls['param_80_gain'].value,
      "param_81_name": this.gainDetailsForm.controls['param_81_name'].value,
      "param_81_gain": this.gainDetailsForm.controls['param_81_gain'].value,
      "param_82_name": this.gainDetailsForm.controls['param_82_name'].value,
      "param_82_gain": this.gainDetailsForm.controls['param_82_gain'].value,
      "param_83_name": this.gainDetailsForm.controls['param_83_name'].value,
      "param_83_gain": this.gainDetailsForm.controls['param_83_gain'].value,
      "param_84_name": this.gainDetailsForm.controls['param_84_name'].value,
      "param_84_gain": this.gainDetailsForm.controls['param_84_gain'].value,
      "param_85_name": this.gainDetailsForm.controls['param_85_name'].value,
      "param_85_gain": this.gainDetailsForm.controls['param_85_gain'].value,
      "param_86_name": this.gainDetailsForm.controls['param_86_name'].value,
      "param_86_gain": this.gainDetailsForm.controls['param_86_gain'].value,
      "param_87_name": this.gainDetailsForm.controls['param_87_name'].value,
      "param_87_gain": this.gainDetailsForm.controls['param_87_gain'].value,
      "param_88_name": this.gainDetailsForm.controls['param_88_name'].value,
      "param_88_gain": this.gainDetailsForm.controls['param_88_gain'].value,
      "param_89_name": this.gainDetailsForm.controls['param_89_name'].value,
      "param_89_gain": this.gainDetailsForm.controls['param_89_gain'].value,
      "param_90_name": this.gainDetailsForm.controls['param_90_name'].value,
      "param_90_gain": this.gainDetailsForm.controls['param_90_gain'].value,
      "param_91_name": this.gainDetailsForm.controls['param_91_name'].value,
      "param_91_gain": this.gainDetailsForm.controls['param_91_gain'].value,
      "param_92_name": this.gainDetailsForm.controls['param_92_name'].value,
      "param_92_gain": this.gainDetailsForm.controls['param_92_gain'].value,
      "param_93_name": this.gainDetailsForm.controls['param_93_name'].value,
      "param_93_gain": this.gainDetailsForm.controls['param_93_gain'].value,
      "param_94_name": this.gainDetailsForm.controls['param_94_name'].value,
      "param_94_gain": this.gainDetailsForm.controls['param_94_gain'].value,
      "param_95_name": this.gainDetailsForm.controls['param_95_name'].value,
      "param_95_gain": this.gainDetailsForm.controls['param_95_gain'].value,
      "param_96_name": this.gainDetailsForm.controls['param_96_name'].value,
      "param_96_gain": this.gainDetailsForm.controls['param_96_gain'].value,
      "param_97_name": this.gainDetailsForm.controls['param_97_name'].value,
      "param_97_gain": this.gainDetailsForm.controls['param_97_gain'].value,
      "param_98_name": this.gainDetailsForm.controls['param_98_name'].value,
      "param_98_gain": this.gainDetailsForm.controls['param_98_gain'].value,
      "param_99_name": this.gainDetailsForm.controls['param_99_name'].value,
      "param_99_gain": this.gainDetailsForm.controls['param_99_gain'].value,
      "param_100_name": this.gainDetailsForm.controls['param_100_name'].value,
      "param_100_gain": this.gainDetailsForm.controls['param_100_gain'].value,
      "param_101_name": this.gainDetailsForm.controls['param_101_name'].value,
      "param_101_gain": this.gainDetailsForm.controls['param_101_gain'].value,
      "param_102_name": this.gainDetailsForm.controls['param_102_name'].value,
      "param_102_gain": this.gainDetailsForm.controls['param_102_gain'].value,
      "param_103_name": this.gainDetailsForm.controls['param_103_name'].value,
      "param_103_gain": this.gainDetailsForm.controls['param_103_gain'].value,
      "param_104_name": this.gainDetailsForm.controls['param_104_name'].value,
      "param_104_gain": this.gainDetailsForm.controls['param_104_gain'].value,
      "param_105_name": this.gainDetailsForm.controls['param_105_name'].value,
      "param_105_gain": this.gainDetailsForm.controls['param_105_gain'].value,
    }
    this.dashbord.addParamGain(gainInfo)
      .pipe(takeUntil(this.ResponseVerifiedGainAddList))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.modalService1.dismissAll();
          this.router.navigate(['inject-solar/inverter-gain-table']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }
}
